import FieldProto from "../../../fields3/proto/field-proto"
import {SortDirection} from "../../../data-structures/sort"
import { DateIntervalType } from "../../utils/datetime/interval"
import ItemModelV2 from "../../../model2/item2/item-model"

export type SingleGrouping = {
    defaultFields       : FieldProto[]
    moreSystemFields    : FieldProto[]
    moreCustomFields    : FieldProto[]
    groupByFolderToggle : boolean
    noGrouping          : boolean
    noGroupingShowLast  : boolean
    groupLabel          : string
}

export type DoubleGrouping = {
    defaultFields       : FieldProto[]
    moreSystemFields    : FieldProto[]
    moreCustomFields    : FieldProto[]
    noGrouping          : boolean
    noGroupingShowLast? : boolean
    group1Label         : string
    group2Label         : string
}

export type GroupingConfig = {
    singleGrouping? : SingleGrouping,
    doubleGrouping  : DoubleGrouping
}

export type GroupByConfig = {
    fieldId?        : ID | null
    sortDirection?  : SortDirection
    params?         : {
        interval?       : DateIntervalType
    }
}

export enum GroupingType {
    HIERARCHY       = 'hierarchy',
    CUSTOM          = 'custom',
    NO_GROUPING     = 'no-grouping',

    ROWS            = 'rows-only',   // board only
    COLUMNS         = 'columns-only',
    ROWS_COLUMNS    = 'rows-and-columns',
}

// export type GroupingObject = {
//     value               : any
//     childrenItemModels  : ItemModelV2[]
// }

export const BUS_GROUPING_UPDATE = "gdUIGroupOptionsButton:update"